import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import { useAuth } from "@/features/auth/composables/useAuth";
import OhVueIcon from "@/icons";
import "@/styles/main.scss";

Office.onReady(() => {
  const app = createApp(App);
  app.use(router);

  app.component("v-icon", OhVueIcon);

  const { setRouterPush } = useAuth();
  setRouterPush((path: string) => router.push(path));

  app.mount("#app");
});
